import BannerPlainTextRepository from "../BannerPlainTextRepository"

export default class PricingSimpleBanner extends BannerPlainTextRepository {
    static schemaId = "pricing_plainBanner"

    constructor() {
        super(PricingSimpleBanner.schemaId)
    }
}
